//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addressComponent from '../../common/address';
export default {
    components: {
        addressComponent
    },
    data() {
        return {
            type: 1,
            editressManageShow: false,
            popupShow: false,
            defaultAddr: false,
            form: {
                name: '',
                phoneNum: '',
                address: ''
            },
            addressList: [],
            addressStr: '',
            inputDisable: true //解决自动聚焦的问题
        };
    },
    //侦听属性
    watch: {
        //监听点击事件
        editressManageShow(value) {
            if (value) {
                document.body.addEventListener('click', () => {
                    this.editressManageShow = false;
                });
            } else {
                document.body.removeEventListener('click', () => {
                    this.editressManageShow = false;
                });
            }
        }
    },
    methods: {
        closePopup() {
            this.type = 1;
            this.editressManageShow = false;
            this.popupShow = false;
            this.defaultAddr = false;
            this.form = {
                name: '',
                phoneNum: '',
                address: ''
            };
            this.addressList = [];
            this.addressStr = '';
            this.$refs.addressComponentRef.closePopup();
            this.inputDisable = true;
        },
        showAddressSelector() {
            if (this.editressManageShow) {
                this.editressManageShow = false;
            } else {
                this.editressManageShow = true;
            }
            this.$refs.addressComponentRef.showPopup(this.addressList);
        },
        showPopup(type, item) {
            this.popupShow = true;
            this.type = type;
            //编辑操作
            if (type == 2 && item) {
                this.form = JSON.parse(JSON.stringify(item));
                this.defaultAddr = item.defaultAddress == 1;
                this.addressStr = item.regionDesc.replace(/\s/g, '/');
                var regionArr = item.regionDesc.split(' ');
                var addressList = [];
                if (regionArr[0]) {
                    addressList.push({
                        regionName: regionArr[0],
                        regionId: item.province
                    });
                }
                if (regionArr[1]) {
                    addressList.push({
                        regionName: regionArr[1],
                        regionId: item.city
                    });
                }
                if (regionArr[2]) {
                    addressList.push({
                        regionName: regionArr[2],
                        regionId: item.prefecture
                    });
                }
                if (regionArr[3]) {
                    addressList.push({
                        regionName: regionArr[3],
                        regionId: item.town
                    });
                }
                this.addressList = addressList;
            }
            this.$nextTick(() => {
                this.inputDisable = false;
            });
        },
        editSubmit() {
            let that = this;
            var one = this.form;
            if (!one.name) {
                that.$vux.toast.text('请填写收货人姓名');
                return false;
            }
            if (!one.phoneNum) {
                that.$vux.toast.text('请填写收货人手机号');
                return false;
            }
            if (!this.addressList || this.addressList.length <= 0) {
                that.$vux.toast.text('请选择省/市/区');
                return false;
            }
            if (!one.address) {
                that.$vux.toast.text('请填写街道门牌、楼层房间号等信息');
                return false;
            }
            var receiverAddress = {
                defaultAddress: that.defaultAddr ? 1 : 0,
                name: one.name,
                phoneNum: one.phoneNum.replace(/\s/g, ''),
                address: one.address,
                addressLabel: ''
            };
            if (this.addressList) {
                receiverAddress.province = this.addressList[0] ? this.addressList[0].regionId : '';
                receiverAddress.city = this.addressList[1] ? this.addressList[1].regionId : '';
                receiverAddress.prefecture = this.addressList[2] ? this.addressList[2].regionId : '';
                receiverAddress.town = this.addressList[3] ? this.addressList[3].regionId : '';
                receiverAddress.regionDesc = this.addressList
                    .map(item => {
                        return item.regionName;
                    })
                    .join(' ');
            }
            //编辑操作
            if (this.type == 2) {
                receiverAddress.receiverAddressId = one.receiverAddressId;
                receiverAddress.accountId = one.accountId;
            }
            var data = {
                receiverAddress: JSON.stringify(receiverAddress),
                shopperId: this.$store.state.userInfo.shopperId
            };
            this.editAjaxSubmit(data);
        },
        editAjaxSubmit(data) {
            let that = this;
            that.$axios.post('/api/v1.0/lonbonShop/saveReceiverAddress', that.qs.stringify(data)).then(function(response) {
                if (response.status == 200) {
                    that.$vux.toast.text('保存成功');
                    that.closePopup();
                    that.$emit('loadList');
                }
            });
        },
        selectAddressHandle(list) {
            this.addressList = list;
            var arr = this.addressList.map(item => {
                return item.regionName;
            });
            this.addressStr = arr.join('/');
            this.editressManageShow = false;
        }
    },
    mounted() {}
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/personalSettings/editAddress.vue